'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var Util;
(function (Util) {
    function property(path) {
        return function (value, key, collection) { return path in value ? value[path] : undefined; };
    }
    Util.property = property;
})(Util = exports.Util || (exports.Util = {}));



//////////////////
// WEBPACK FOOTER
// ./src/typescripts/shared/utils/util.ts
// module id = 23
// module chunks = 0 1